import $ from 'jquery';

/**
 * Function TabCtrl
 */
function TabCtrl() {
  this.$tab = $('.tab');
  this.$navi = this.$tab.find('.tab-navi');
  this.$naviAnchor = this.$navi.find('a[href^="#"]');

  this.naviClick = this.naviClick.bind(this);

  this.init();
}

TabCtrl.prototype.init = function () {
  this.$naviAnchor.on('click mousedown', this.naviClick);
}

TabCtrl.prototype.naviClick = function (e) {
  e.preventDefault();
  var self = this;
  var $self = $(e.currentTarget);
  var target = $self.get(0).hash;
  var $target = $(target);
  $self.parent().addClass('active').siblings().removeClass('active');
  if (typeof $target.get(0) !== 'undefined') {
    $target.addClass('active').siblings().removeClass('active');
  }
}


export default TabCtrl;